interface FormTextAreaProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  required?: boolean;
  showCounter?: boolean;
  className?: string;
}

export default function FormTextArea({
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  maxLength = 500,
  required = false,
  showCounter = true,
  className = '',
}: FormTextAreaProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && '*'}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 resize-none"
        placeholder={placeholder}
        maxLength={maxLength}
        required={required}
      />
      {showCounter && (
        <p className="text-xs text-gray-500 mt-1">
          {value.length}/{maxLength}자
        </p>
      )}
    </div>
  );
}
